// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectionGuide_container__p_k2l"};